import { GetAllCustomersDto } from './CustomerService';

import { httpClient } from '@/lib/httpClient';

export enum Status {
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
  PARTIAL = 'PARTIAL',
  DONE = 'DONE',
  ERROR = 'ERROR',
}

export enum CSVType {
  PRODUCT = 'PRODUCT',
  SHOP_THE_LOOK = 'SHOP_THE_LOOK',
}

export interface CSVFile {
  id: string;
  customerId: number;
  customer: Partial<GetAllCustomersDto>;
  type: CSVType;
  status: Status;
  errorMessage: string | null;
  createdAt: string;
  updatedAt: string;
  originalName: string;
  fileKey: string;
}

export interface CSVQueryFilterDto {
  page: number;
  limit: number;
  type?: string;
}

export interface GetCSVResponseDto {
  totalPages: number;
  currentPage: number;
  totalItems: number;
  items: CSVFile[];
}

export interface CSVUploadDto {
  fileKey: string;
  originalName: string;
  type?: CSVType | null;
}

export interface SignedUrlResponse {
  fileKey: string;
  url: string;
}

export interface CSVListItem {
  id: number;
  originalName: string;
  fileKey: string;
}

class CsvService {
  async getCsvs(csvQueryFilterDto: CSVQueryFilterDto) {
    const { data } = await httpClient.get<GetCSVResponseDto>(
      `/v1/csv-imports`,
      {
        params: csvQueryFilterDto,
      },
    );
    return data;
  }

  async getSignedUrl() {
    const { data } = await httpClient.get<SignedUrlResponse>(
      `/v1/csv-imports/signed-url`,
    );
    return data;
  }

  async createCsv(csvUploadDto: CSVUploadDto) {
    const { data } = await httpClient.post<CSVFile>(
      `/v1/csv-imports`,
      csvUploadDto,
    );
    return data;
  }

  async listCsvs() {
    const { data } =
      await httpClient.get<CSVListItem[]>(`/v1/csv-imports/list`);
    return data;
  }
}

export default new CsvService();
